import { ActionIcon, Avatar, Badge, Box, Button, Group, Image, Text, Tooltip, useMantineColorScheme } from '@mantine/core';
import { useMediaQuery } from "@mantine/hooks";
import { IconCircleChevronLeft, IconCircleChevronRight, IconAlertTriangle, IconSearch } from "@tabler/icons-react";

import { useNavigationBarState } from "./NavigationBar";
import { useSearch } from "../../functions/SearchBox.hook";
import ThemeToggle from "../Shared/ThemeToggle";

export const HeaderBar = () => {
	const isMobile = useMediaQuery('(max-width: 48em)');
	const { colorScheme } = useMantineColorScheme();
	const { isOpen: navigationOpened, toggle: toggleNavigation } = useNavigationBarState();
	const { SearchBox, visible: searchVisible, setVisible: setSearchVisible, showSearch } = useSearch();
	const logoPath = colorScheme === "light" ? `/${import.meta.env.VITE_ICON192}` : `/${import.meta.env.VITE_ICON192_WHITE}`;

	return <>
		<Group h="100%" px="md" style={{ boxShadow: 'rgba(0, 0, 0, 0.05) 0px 2px 12px' }} justify='space-between' wrap="nowrap">
			<Group gap="xs" wrap="nowrap" justify="left" w="100%">
				<Group gap="xs" wrap="nowrap">
					{/* <Burger opened={opened} onClick={() => handleNavigationToggled(!opened)} size="sm" /> */}
					{(navigationOpened || isMobile) && <>
						<Tooltip label="Collapse Navigation" color="var(--mantine-primary-color-filled)" withArrow arrowSize={10} position="right" radius="sm">
							<ActionIcon radius="xl" variant="subtle" color="indigo.3" bg="var(--mantine-color-body" ml={navigationOpened && !isMobile ? -30 : 0 } mt={3} onClick={toggleNavigation}>{navigationOpened ? <IconCircleChevronLeft /> : <IconCircleChevronRight /> }</ActionIcon>
						</Tooltip>
					</>
					}

					<Group gap="xs" hiddenFrom={navigationOpened ? "sm" : "" } wrap="nowrap">
						<Avatar><Image src={logoPath} /></Avatar>
						<Text fw="bold" size="18px">{import.meta.env.VITE_NAV_TITLE}</Text>
					</Group>

				</Group>

				<Box visibleFrom="sm" w="100%" className="searchBar">
					{SearchBox}
				</Box>
			</Group>

			<Group hiddenFrom="sm" wrap="nowrap">
				{showSearch && 
				<ActionIcon variant={searchVisible ? "light" : "subtle"} color={searchVisible ? "indigo.5" : "gray.5"} radius="xl" onClick={() => setSearchVisible(!searchVisible)}><IconSearch size={16} /></ActionIcon>
				}
			</Group>

			<Group visibleFrom="sm" wrap="nowrap">
				{!import.meta.env.MODE.includes('production') &&
				<Badge leftSection={<IconAlertTriangle size={14} />} miw={170}>Test environment</Badge>
				}
				<ThemeToggle />
			</Group>

		</Group>
	</>
}